import { Component, computed, inject } from '@angular/core';
import { AuthLayoutComponent } from '../auth-layout/auth-layout';
import {
  FormBuilder,
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { RestorePasswordService } from '../../services/restore-password.service';
import { SnackbarService } from '@/app/shared/services/snackbar.service';
import { ThemeService } from '@/app/core/services/theme/theme.service';

@Component({
  selector: 'app-reset-password',
  standalone: true,
  imports: [AuthLayoutComponent, FormsModule, ReactiveFormsModule],
  templateUrl: './reset-password.html',
  styleUrl: './reset-password.scss',
})
export class ResetPassword {
  private formBuilder = inject(FormBuilder);
  private router = inject(Router);
  private restorePasswordService = inject(RestorePasswordService);
  private snackbarService = inject(SnackbarService);
  private themeService = inject(ThemeService);

  protected themeContent = this.themeService.themeContent;
  protected resetPasswordContent = computed(() => this.themeContent()?.authComponent.resetPasswordComponent);
  protected submitted = false;
  protected showValidateCode = false;
  protected showFormPassword = false;

  onSubmit() {
    this.submitted = true;

    if (this.formResetPasword.invalid) {
      return;
    }
    this.restorePasswordService
      .sendResetPasswordEmail(this.formResetPasword.value.email!)
      .subscribe({
        next: () => {
          this.router.navigate(['/message'], { queryParams: { message: 'Correo enviado, continúa el proceso en la bandeja de tu correo', title: '¡Correo enviado!', buttonText: 'Entendido' } });
        },
        error: (error) => {
          console.log(error);
          this.snackbarService.showError(
            'Error al enviar el correo de restablecimiento de contraseña. Por favor, intente más tarde o contacte con el administrador.'
          );
        },
      });
  }

  formResetPasword = this.formBuilder.group({
    email: new FormControl('', [Validators.required, Validators.email]),
  });

  get email() {
    return this.formResetPasword.get('email');
  }

  onCancel() {
    this.router.navigate(['/iniciar']);
  }
}
